import { FC } from 'react';

import { Heading, Modal } from '@belong/ui-components';

import CONTENT from './content.json';

type ChatQuitModalProps = {
  onConfirm?: () => void;
  onCancel?: () => void;
};

export const ChatQuitModal: FC<ChatQuitModalProps> = ({ onConfirm, onCancel }) => (
  <Modal
    isOpen
    ariaLabelClose={CONTENT.ariaLabels.closeModal}
    onClose={() => onCancel?.()}
    defaultContent={CONTENT.quitModal.content}
    defaultHeading={<Heading variant="medium">{CONTENT.quitModal.heading}</Heading>}
    defaultObject={{
      primaryBtnLabel: CONTENT.quitModal.confirm,
      secondaryBtnLabel: CONTENT.quitModal.cancel,
      primaryAction: onConfirm,
      secondaryAction: onCancel
    }}
  />
);

ChatQuitModal.displayName = 'ChatQuitModal';
